<template>
  <div>
    <el-timeline-item
      v-if="content"
      :icon="icon"
      :type="type"
      :color="color"
      size="large"
      :timestamp="formatDate(activity.createdOn)"
    >
      <div v-html="formatActivityDataText" class=""></div>
      <div v-if="hasCountyAvailabilityData">
        <county-availability-dropdown
          :data="data?.validityResults || {}"
          :show-action="false"
        />
      </div>
    </el-timeline-item>
  </div>
</template>

<script>
import ActivitiesTimelineMixin from "@/components/ActivitiesView/ActivitiesTimelineMixin.vue";
import CountyAvailabilityDropdown from "@/components/Quotes/CountyAvailabilityDropdown.vue";

export default {
  mixins: [ActivitiesTimelineMixin],
  components: {
    CountyAvailabilityDropdown
  },
  props: {
    activity: {
      type: Object,
      required: true
    },
    countyValidityCheck: {
      type: Object,
      required: false
    }
  },
  methods: {
    formatCountyAvailabilityData(isAvailable = false) {
      const validityResults = this.data?.validityResults || {};
      return isAvailable ? validityResults?.allowed : validityResults?.blocked;
    }
  },
  watch: {
    activity: {
      async handler() {
        this.content = "";
        this.icon = "";
        this.type = "";
        this.link = {};
        this.color = "";
        switch (this.activity.name) {
          case "ADD_COUNTY_VALIDITY_CHECK_SUCCESS":
            this.generateReadableGeneric({
              content: "validated a county.",
              icon: "el-icon-document",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "ADD_COUNTY_VALIDITY_CHECK_FAILURE":
            this.generateReadableFailGeneric({
              content: "failed to validate a county.",
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
        }
      },
      immediate: true
    }
  },
  computed: {
    formatActivityDataText() {
      return `${this.formattedActivityText}
      <div>
      <p> ${this.data?.county ? `County: ${this.data.county}` : ""}</p>
      <p>Effective: ${this.data?.effectiveDate}</p>
      </div>`;
    },
    hasCountyAvailabilityData() {
      return (
        this.data?.validityResults &&
        Object.keys(this.data?.validityResults).length > 0
      );
    }
  }
};
</script>

<style></style>
